












































































import DateMixin from "@/mixins/DateMixin";
import AccountIdValdationMixin from "@/mixins/AccountIdValdationMixin";
import { Component, Mixins } from "vue-property-decorator";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import FormValidator from "@/mixins/FormValidator";
import RedStar from "@/components/ui/RedStar.vue";
import { AuthModule } from "@/store/auth.module";
import { DalModule } from "@/store/dal.module";
import { BaseModule } from "@/store/base.module";

@Component({
  components: { MonthPicker, RedStar },
})
export default class PersonalChangeView extends Mixins(
  DateMixin,
  AccountIdValdationMixin,
  FormValidator,
) {
  formRef = "formChangePersonal";
  firstname: string = null as any;
  lastname: string = null as any;
  middlename: string = null as any;
  loading: boolean = false;

  async saveData() {
    try {
      this.loading = true;
      if (!this.validateForm()) return;
      const checkSave = await DalModule.updatePersonalData({
        FirstName: this.firstname.trim(),
        LastName: this.lastname.trim(),
        MiddleName: this.middlename ? this.middlename.trim() : (null as any),
      });
      if (checkSave === true) {
        await AuthModule.getUser();
        BaseModule.showMessage({
          message: "personal.dataUpdated",
        });
      }
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    await AuthModule.getUser();
    if (AuthModule.user) {
      this.firstname = AuthModule.user.firstname!;
      this.lastname = AuthModule.user.lastname!;
      this.middlename = AuthModule.user.middlename!;
    }
  }
}
